import { AlertTriangle, MapPinOff, Loader, RefreshCw } from 'lucide-react';

export default function LocationSharingRequired({ state, handleForceLocationPrompt }) {
  return (
    <div className="container mx-auto p-6">
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-md shadow-sm">
        <div className="flex justify-between">
          <div className="flex">
            <div className="flex-shrink-0">
              <AlertTriangle className="h-5 w-5 text-yellow-400" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-yellow-800">Location Access Required</h3>
              <div className="mt-2 text-sm text-yellow-700">
                <p>When working remotely, you must enable location access to use this application. Please follow these steps:</p>
                <ol className="list-decimal ml-4 mt-2">
                  <li>Click the location icon <MapPinOff className="inline h-4 w-4" /> in your browser's address bar</li>
                  <li>Select "Allow" for location access</li>
                  <li>Click the "Request Location Access" button below</li>
                </ol>
                {state.showResetInstructions && (
                  <div className="mt-4 p-4 bg-blue-50 rounded-md border border-blue-100">
                    <p className="font-medium text-blue-800">If you don't see the location prompt:</p>
                    <ol className="list-decimal ml-4 mt-2">
                      <li>Click the lock/info icon in your browser's address bar</li>
                      <li>Find "Location" in the site settings</li>
                      <li>Reset the permission to "Ask" or "Allow"</li>
                      <li>Refresh the page and try again</li>
                    </ol>
                  </div>
                )}
              </div>
              <div className="mt-4 flex gap-4">
                <button
                  onClick={handleForceLocationPrompt}
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 transition-colors"
                >
                  {state.isLoading ? (
                    <>
                      <Loader className="animate-spin -ml-1 mr-2 h-4 w-4" />
                      Checking Location...
                    </>
                  ) : (
                    <>
                      <MapPinOff className="mr-2 h-4 w-4" />
                      Request Location Access
                    </>
                  )}
                </button>
                <button
                  onClick={() => window.location.reload()}
                  className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 transition-colors"
                >
                  <RefreshCw className="mr-2 h-4 w-4" />
                  Refresh Page
                </button>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center text-red-500 mr-8">
            <div className="text-3xl mb-2">↑</div>
            <MapPinOff className="w-6 h-6 mb-1" />
            <span className="text-xs text-center whitespace-nowrap">Click this icon<br />in browser bar</span>
          </div>
        </div>
        {/* Indonesian version */}
        <div className="flex justify-between mt-6 pt-4 border-t border-yellow-200">
          <div className="flex">
            <div className="flex-shrink-0">
              <AlertTriangle className="h-5 w-5 text-yellow-400" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-yellow-800">Akses Lokasi Diperlukan</h3>
              <div className="mt-2 text-sm text-yellow-700">
                <p>Saat bekerja dari jarak jauh, Anda harus mengaktifkan akses lokasi untuk menggunakan aplikasi ini. Ikuti langkah-langkah berikut:</p>
                <ol className="list-decimal ml-4 mt-2">
                  <li>Klik ikon lokasi <MapPinOff className="inline h-4 w-4" /> di bilah alamat browser Anda</li>
                  <li>Pilih "Izinkan" untuk akses lokasi</li>
                  <li>Klik tombol "Minta Akses Lokasi" di bawah</li>
                </ol>
                {state.showResetInstructions && (
                  <div className="mt-4 p-4 bg-blue-50 rounded-md border border-blue-100">
                    <p className="font-medium text-blue-800">Jika Anda tidak melihat prompt lokasi:</p>
                    <ol className="list-decimal ml-4 mt-2">
                      <li>Klik ikon kunci/info di bilah alamat browser</li>
                      <li>Temukan "Lokasi" di pengaturan situs</li>
                      <li>Atur ulang izin ke "Tanya" atau "Izinkan"</li>
                      <li>Segarkan halaman dan coba lagi</li>
                    </ol>
                  </div>
                )}
              </div>
              <div className="mt-4 flex gap-4">
                <button
                  onClick={handleForceLocationPrompt}
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 transition-colors"
                >
                  {state.isLoading ? (
                    <>
                      <Loader className="animate-spin -ml-1 mr-2 h-4 w-4" />
                      Memeriksa Lokasi...
                    </>
                  ) : (
                    <>
                      <MapPinOff className="mr-2 h-4 w-4" />
                      Minta Akses Lokasi
                    </>
                  )}
                </button>
                <button
                  onClick={() => window.location.reload()}
                  className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 transition-colors"
                >
                  <RefreshCw className="mr-2 h-4 w-4" />
                  Segarkan Halaman
                </button>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center text-red-500 mr-8">
            <div className="text-3xl mb-2">↑</div>
            <MapPinOff className="w-6 h-6 mb-1" />
            <span className="text-xs text-center whitespace-nowrap">Klik ikon ini<br />di bilah browser</span>
          </div>
        </div>
      </div>
    </div>
  );
} 